import clsx from "clsx";
import React from "react";
import { Dropdown } from "../../../../common/components/dropdown/Dropdown";
import { generateDropdownItems, onYearClick } from "../forecast/dropdowns";
import { fromToDropdownsType } from "../../../../common/types/search/search";
import { ValidationResult } from "../../validation/validationResult";

interface FromToDropdownsProps {
	apiData?: object;
	currentInput: fromToDropdownsType;
	onInputChange: (input: fromToDropdownsType) => unknown;
	dateRangeCheck: (currentInput: fromToDropdownsType) => ValidationResult;
	disclaimer?: string;
}

export function FromToDropdowns({
	apiData,
	currentInput,
	onInputChange,
	dateRangeCheck,
	disclaimer,
}: FromToDropdownsProps) {
	if (!apiData) {
		return null;
	}

	const fromYear = currentInput.get("from_year", "");
	const fromMonth = currentInput.get("from_month", "");
	const toYear = currentInput.get("to_year", "");
	const toMonth = currentInput.get("to_month", "");
	const dropdownItems = generateDropdownItems(
		apiData,
		fromYear,
		toYear,
		true,
	);

	const validationResult = dateRangeCheck(currentInput);
	const error = validationResult.isError() && (
		<span className="error-text">{validationResult.getMessage()}</span>
	);
	const errorClasses = clsx("criterion__section", {
		error: validationResult.isError(),
	});

	const onChange = (key: string, value: string) => {
		switch (key) {
			case "from_year":
				onYearClick(
					"from",
					value,
					apiData,
					currentInput,
					onInputChange,
				);
				break;

			case "to_year":
				onYearClick("to", value, apiData, currentInput, onInputChange);
				break;

			default:
				onInputChange(currentInput.set(key, value));
		}
	};

	return (
		<div className={errorClasses}>
			<div className="criterion__section-choices">
				<p>From</p>
				<div className="choices-section-dropdowns">
					<Dropdown
						dropdownItems={dropdownItems.from.years}
						dropdownToggle={fromYear}
						onDropdownItemClick={(id) => onChange("from_year", id)}
						preselected={true}
						dropdownKey="dropdown_range_from_years"
						label="From year"
					/>
					<Dropdown
						dropdownItems={dropdownItems.from.months}
						dropdownToggle={fromMonth}
						onDropdownItemClick={(id) => onChange("from_month", id)}
						preselected={true}
						dropdownKey="dropdown_range_from_months"
						label="From month"
					/>
				</div>
			</div>

			<div className="criterion__section-choices">
				<p>To</p>
				<div className="choices-section-dropdowns">
					<Dropdown
						dropdownItems={dropdownItems.to.years}
						dropdownToggle={toYear}
						onDropdownItemClick={(id) => onChange("to_year", id)}
						preselected={true}
						dropdownKey="dropdown_range_to_years"
						label="To year"
					/>
					<Dropdown
						dropdownItems={dropdownItems.to.months}
						dropdownToggle={toMonth}
						onDropdownItemClick={(id) => onChange("to_month", id)}
						preselected={true}
						dropdownKey="dropdown_range_to_months"
						label="To month"
					/>
				</div>
			</div>

			{error}
			{disclaimer && <span>{disclaimer}</span>}
		</div>
	);
}
